import React from "react";
import isPropValid from "@emotion/is-prop-valid";
import { StyleSheetManager } from "styled-components";

/*
 * styled-components v6 no longer filters props before they reach the DOM, and no longer
 * adds vendor prefixes. Restore the v5 behaviour for the whole site so styling props
 * (e.g. `margin`, `isActive`) stay off HTML elements.
 */
function shouldForwardProp(propName, target) {
  if (typeof target === "string") return isPropValid(propName);
  return true;
}

export function wrapStyledRoot(element) {
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp} enableVendorPrefixes>
      {element}
    </StyleSheetManager>
  );
}
